import { AbilityBuilder, Ability } from '@casl/ability'
import Roles from '../models/roles'
import { RolePermissions } from './Permissions'

const defineAbility = (user: any) => {
  const { can, build } = new AbilityBuilder(Ability)
  if (!user) return build()

  const { agency_role }: { agency_role?: Roles } = user

  if (agency_role) {
    for (let [entity, entityPermissions] of Object.entries(RolePermissions[agency_role])) {
      for (let [action, isAllow] of Object.entries(entityPermissions)) {
        if (isAllow) can(action, entity)
      }
    }
  }

  return build()
}

export default defineAbility
